function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { classnames, deepEqual } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useAutoComplete } from '../../hooks/autocomplete';
import { useGetTrigger } from '../../hooks/popper';
import { TreeMapState } from '../../models/tree-map';
import { HighlightKeyword } from '../util/HighlightKeyword';
import { AutoSizedList } from '../../units/auto-sized-list';
import { ListItem } from '../util/ListItem';
import { Empty } from '../empty';
export function AutoCompletePanel(props) {
  var triggerId = props.triggerId,
      _props$autoAlign = props.autoAlign,
      autoAlign = _props$autoAlign === void 0 ? true : _props$autoAlign,
      _props$popoverHeight = props.popoverHeight,
      popoverHeight = _props$popoverHeight === void 0 ? 200 : _props$popoverHeight,
      _props$popoverWidth = props.popoverWidth,
      popoverWidth = _props$popoverWidth === void 0 ? 110 : _props$popoverWidth,
      _props$rowHeight = props.rowHeight,
      rowHeight = _props$rowHeight === void 0 ? 34 : _props$rowHeight,
      popoverClassName = props.popoverClassName,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent,
      onClick = props.onClick,
      domRef = props.domRef;
  var autoComplete = useAutoComplete();
  var activeIndex = autoComplete.activeIndex,
      selectedValue = autoComplete.selectedValue,
      checkable = autoComplete.checkable,
      multiple = autoComplete.multiple,
      keyword = autoComplete.keyword;
  var dataSource = autoComplete.getFilterData();
  var renderSearchItem = autoComplete.getRenderSearchItem();
  var activeTrigger = useGetTrigger(triggerId);
  var activeItemCls = usePrefixCls('auto-complete-item-active');
  var panelWidth = autoAlign && activeTrigger ? activeTrigger.getRect().width : popoverWidth;
  var panelCls = classnames(usePrefixCls('auto-complete-panel', {
    empty: !dataSource.length
  }), popoverClassName);
  var localeEmpty = useLocale('auto-complete.empty');

  var renderItem = function renderItem(_ref) {
    var key = _ref.key,
        index = _ref.index,
        style = _ref.style;
    var _dataSource$index = dataSource[index],
        label = _dataSource$index.label,
        value = _dataSource$index.value;
    var activeCls = classnames(_defineProperty({}, activeItemCls, index === activeIndex));
    var isChosen = selectedValue.some(function (item) {
      return deepEqual(item.value, value);
    });
    return React.createElement("div", {
      key: key,
      style: style,
      className: activeCls
    }, React.createElement(ListItem, {
      prefixCls: "auto-complete-option",
      checkable: checkable && multiple,
      chosen: (!checkable || !multiple) && isChosen,
      onMouseDown: function onMouseDown() {
        return autoComplete.handleSelect({
          label: label,
          value: value
        });
      },
      onCheckboxChange: function onCheckboxChange() {
        return autoComplete.handleSelect({
          label: label,
          value: value
        });
      },
      state: isChosen ? TreeMapState.SELECTED : TreeMapState.UNSELECTED
    }, renderSearchItem ? renderSearchItem(dataSource[index]) : React.createElement(HighlightKeyword, {
      label: label,
      keyword: keyword,
      caseSensitive: false
    })));
  };

  return React.createElement("div", {
    ref: domRef,
    style: {
      width: "".concat(panelWidth, "px"),
      height: "".concat(popoverHeight, "px")
    },
    className: panelCls,
    onClick: onClick
  }, dataSource.length ? React.createElement(AutoSizedList, {
    rowHeight: rowHeight,
    rowCount: dataSource.length,
    rowRenderer: renderItem
  }) : (autoComplete.showEmpty || multiple) && (emptyRender ? emptyRender(localeEmpty, keyword) : React.createElement(Empty, {
    content: emptyContent ? emptyContent(localeEmpty, keyword) : localeEmpty
  })));
}